export default __webpack_public_path__ + "static/icon-31-6-0ed2c8af6ad9508f03db8caaeea57e3c.png";